// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"productCheck_checkboxContainer__RCSxT","checkmark":"productCheck_checkmark__4pRku"};